<template>
    <el-pagination background @size-change="handleChange" @current-change="currentChange"
        layout="total, sizes, prev, pager, next, jumper" :current-page="params.pageNum" :page-size="params.size"
        :page-sizes="params.isDefaultPageSizes ? [10,20,50,100] :[20, 50, 100, 200]" :total="params.total" v-show="params.total>0">
    </el-pagination>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        params: {
            total:{default:0},
            pageNum:1,
            isDefaultPageSizes:true,
            pageSize: {default:20}
        },
    },
    data() {
        return {
        }
    },
    computed: {
    },
    created() {
        this.$emit('pageBind');
    },
    methods: {
        handleChange(size) {
            if (this.params.pageNum * size > this.params.total) { 
                //防止请求两次
                this.params.pageNum = 1;
            }
            //size 每页条数改变时会触发
            this.params.pageSize = size;
            //向父组件发射页面条数改变后的状态值
            this.$emit('pageBind');
        },
        currentChange(pageNum) {
            //current 改变时会触发
            this.params.pageNum = pageNum;
            //向父组件发射当前页改变后的状态值
            this.$emit('pageBind');
        }
    },
}
</script>

<style scope>
.el-pagination{margin-top:20px;}
</style>